module.exports = __webpack_public_path__ + "img/home.176f5b7f.jpeg";